(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2019,6245],{

/***/ 6635:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/whitepaper/[slug]",
      function () {
        return __webpack_require__(7545);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ContactUsHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
// import ButtonArrow from "../reusable/ButtonArrow";
// export default function ContactUsHome() {
//   return (
//     <section className="relative h-[30vh] md:h-[30vh] w-full bg-gradient-to-b from-white to-gray-200">
//       <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
//         <h1 className="text-4xl sm:text-6xl  text-black">
//           How can we help you?
//           {/* Careers */}
//         </h1>
//         <ButtonArrow 
//           txt="Contact us"
//           link="/contact-us"
//           style="w-[170px] text-black hover:no-underline text-lg font-medium"
//           className="text-center"
//         />
//       </div>
//     </section>
//   );
// }
// import Link from "next/link";
// export default function ContactUsHome() {
//     return (
//       <div className="w-full bg-gradient-to-t from-amber-50 to-white ">
//         <div className="max-w-3xl mx-auto px-4 text-center">
//           <h2 className="text-3xl font-bold text-gray-800 mb-4">
//             Ready to Transform Your Business?
//           </h2>
//           <p className="text-lg text-gray-600 mb-8">
//           Join industry leaders who've already discovered how our solutions can drive growth. Our team is ready to create your custom solution to give you a competitive edge.
//           </p>
//           <div className="mb-8">
//             <a 
//               href="/contact-us"
//               className="inline-block group relative overflow-hidden rounded-lg bg-amber-600 px-8 py-4 text-white transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
//             >
//               <span className="relative z-10 text-lg font-semibold">
//               Schedule Your Consultation
//               </span>
//               <div className="absolute inset-0 bg-gradient-to-r from-amber-500 to-amber-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
//             </a>
//           </div>
//         </div>
//       </div>
//     )
//   }


function ContactUsHome() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full bg-gradient-to-t from-amber-50 to-white mt-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-3xl mx-auto pb-7 px-4 text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-3xl font-bold text-gray-800 mb-4",
                    children: "Ready to Transform Your Business?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-lg text-gray-600 mb-8",
                    children: [
                        "Join industry leaders already scaling with our",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/services/custom-software-development",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-amber-700 font-medium hover:underline",
                                children: "custom software solutions"
                            })
                        }),
                        ". Let’s build the tools your business needs to grow faster and stay ahead."
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "py-5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/contact-us",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: "inline-block group relative overflow-hidden rounded-lg bg-amber-600 px-8 py-4 text-white transform transition-all duration-300 hover:scale-105 hover:shadow-xl",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "relative z-10 text-lg font-semibold",
                                    children: "Schedule Your Consultation"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute inset-0 bg-gradient-to-r from-amber-500 to-amber-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 7545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ WhitePaperPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/homepage/ContactUsHome.js
var ContactUsHome = __webpack_require__(6245);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react-dom/client.js
var client = __webpack_require__(745);
;// CONCATENATED MODULE: ./components/blog/MetaMetricRenderer.js



var MetaMetricRenderer = function(param) {
    var metrics = param.metrics;
    (0,react.useEffect)(function() {
        metrics.forEach(function(metric, index) {
            var container = document.getElementById("dynamic-metric-".concat(index + 1));
            if (container) {
                var root = (0,client.createRoot)(container);
                root.render(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-10 p-6 rounded-lg border",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-3xl my-0",
                            children: metric.heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 gap-4",
                            children: metric.values.map(function(item, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center text-center ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-4xl font-bold border-b-2 border-[#f1aa4e]",
                                            children: item.value
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-gray-600 my-0",
                                            children: item.description
                                        })
                                    ]
                                }, idx);
                            })
                        })
                    ]
                }));
            }
        });
    }, [
        metrics
    ]);
    return null;
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./pages/blog/whitepaper/[slug].js




var Footer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3474).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
var Navbar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2684), __webpack_require__.e(7804), __webpack_require__.e(1548)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: false
});
var GetInTouch = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4601), __webpack_require__.e(8853)]).then(__webpack_require__.bind(__webpack_require__, 8853));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8853)
            ];
        }
    },
    ssr: false
});




var __N_SSG = true;
function WhitePaperPage(param) {
    var content = param.content, metadata = param.metadata;
    var createMarkup = function createMarkup(content) {
        var quotes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], metrics = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        var modifiedContent = content;
        // let quoteIndex = 0;
        quotes.forEach(function(quote, index) {
            modifiedContent = modifiedContent.replace("{{quote_".concat(index + 1, "}}"), '<blockquote class="border-l-4 border-[#f1aa4e] pl-4 italic text-gray-500 font-semibold text-2xl py-5">\n              '.concat(quote, "\n          </blockquote>"));
        });
        // Replace each {{metric_X}} placeholder with an empty div
        metrics.forEach(function(metric, index) {
            modifiedContent = modifiedContent.replace("{{metric_".concat(index + 1, "}}"), '<div id="dynamic-metric-'.concat(index + 1, '"></div>'));
        });
        return {
            __html: modifiedContent
        };
    };
    var ref = (0,react.useState)(false), showButton = ref[0], setShowButton = ref[1];
    // const [isModalOpen, setIsModalOpen] = useState(false);
    (0,react.useEffect)(function() {
        var imageSection = document.getElementById("image-section");
        var footer = document.getElementById("contact-us");
        if (!imageSection || !footer) return;
        var observer = new IntersectionObserver(function(entries) {
            var isImageVisible = false;
            var isFooterVisible = false;
            entries.forEach(function(entry) {
                if (entry.target === imageSection) {
                    isImageVisible = entry.isIntersecting;
                }
                if (entry.target === footer) {
                    isFooterVisible = entry.isIntersecting;
                }
            });
            // Show button when image is **out of view** and footer is **not in view**
            setShowButton(!isImageVisible && !isFooterVisible);
        }, {
            threshold: 0.3
        });
        observer.observe(imageSection);
        observer.observe(footer);
        return function() {
            return observer.disconnect();
        };
    }, []);
    var ref1 = (0,react.useState)("text-4xl"), fontSize = ref1[0], setFontSize = ref1[1];
    (0,react.useEffect)(function() {
        var handleResize = function() {
            setFontSize(window.innerWidth < 640 ? "text-3xl" : "text-4xl");
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metadata === null || metadata === void 0 ? void 0 : metadata.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: metadata === null || metadata === void 0 ? void 0 : metadata.keywords
                    }),
                    (metadata === null || metadata === void 0 ? void 0 : metadata.author) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: metadata === null || metadata === void 0 ? void 0 : metadata.author
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metadata === null || metadata === void 0 ? void 0 : metadata.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metadata === null || metadata === void 0 ? void 0 : metadata.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat("https://www.itmtb.com" + (metadata === null || metadata === void 0 ? void 0 : metadata.img))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "".concat("https://www.itmtb.com" + (metadata === null || metadata === void 0 ? void 0 : metadata.slug))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metadata === null || metadata === void 0 ? void 0 : metadata.subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metadata === null || metadata === void 0 ? void 0 : metadata.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat("https://www.itmtb.com" + (metadata === null || metadata === void 0 ? void 0 : metadata.img))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metadata === null || metadata === void 0 ? void 0 : metadata.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/svg",
                        href: "/favicon.svg",
                        sizes: "16x16"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mb-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "image-section",
                        className: "flex flex-col lg:flex-row w-full lg:h-screen justify-start lg:justify-center mt-14 lg:mt-16 lg:py-0 py-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "prose md:prose-xl lg:prose-xl lg:w-1/2 w-full flex flex-col items-start lg:items-center h-full justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg:px-12 px-6 lg:my-0 my-10 w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-gray-900 border-b-2 border-[#f1aa4e]",
                                                children: "White Paper"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "".concat(fontSize, " font-sans font-medium !mb-0 !mt-5"),
                                                children: metadata === null || metadata === void 0 ? void 0 : metadata.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "text-gray-500 font-normal !mt-4",
                                                children: metadata === null || metadata === void 0 ? void 0 : metadata.subtitle
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-1/2 w-full flex justify-center",
                                children: (metadata === null || metadata === void 0 ? void 0 : metadata.img) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: metadata.img,
                                    alt: metadata.title,
                                    className: "w-full shadow-md aspect-square",
                                    width: 1200,
                                    height: 800,
                                    priority: true,
                                    sizes: "(max-width: 700px) 90vw, (max-width: 1024px) 80vw, 50vw",
                                    placeholder: "blur",
                                    blurDataURL: "/blogImages/hero/placeholder.webp"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-4xl mx-auto mt-10 px-6 lg:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-[#f1aa4e] text-3xl font-semibold",
                                        children: "At a Glance"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: " my-3 border-t-2 border-[#f1aa4e]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "list-disc pl-5",
                                        children: [
                                            metadata.at_a_glance.map(function(point, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "text-gray-700 text-xl my-6 marker:text-[#f1aa4e]",
                                                    children: point
                                                }, index);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-left max-w-4xl text-md md:text-xl mt-10 text-gray-900 prose mx-auto",
                                dangerouslySetInnerHTML: createMarkup(content, metadata.quotes, metadata.metrics)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaMetricRenderer, {
                                metrics: metadata.metrics
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "w-10/12 mx-auto mb-12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsHome["default"], {}),
            showButton && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/blog/future-proof-your-hospitality-supply-chain",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "fixed bottom-5 right-5 bg-amber-600 text-white rounded-lg shadow-lg z-50 hover:translate-x-1 transition-all duration-300 inline-flex gap-2 p-3 cursor-pointer",
                    children: "Read Full White Paper"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "contact-us",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,7446,9774,2888,179], function() { return __webpack_exec__(6635); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);